import { EsigningProviderAuthenticationModeSlug, } from 'shared/domains/apollo/generated/types';
const areRecipientsEqual = (recipientA, recipientB) => {
    const uniqueIdentifierA = `${recipientA.email}-${recipientA.firstName}-${recipientA.lastName}`;
    const uniqueIdentifierB = `${recipientB.email}-${recipientB.firstName}-${recipientB.lastName}`;
    return uniqueIdentifierA === uniqueIdentifierB;
};
const areRecipientArraysEqual = (arrayA, arrayB) => {
    if (arrayA.length !== arrayB.length) {
        return false;
    }
    return arrayA.every((recipientA) => arrayB.some((recipientB) => areRecipientsEqual(recipientA, recipientB)));
};
export const areComposerRecipientsEqual = (composers) => {
    if (composers.length <= 1) {
        return true;
    }
    const firstComposer = composers[0];
    return composers
        .slice(1)
        .every((composer) => areRecipientArraysEqual(firstComposer.defaultRecipients, composer.defaultRecipients));
};
export const areComposerRecipientsPopulated = (composers) => composers.some((composer) => composer.defaultRecipients.length > 0 || composer.defaultRecipients.length > 0);
export const mapDefaultSignerRecipient = (recipient) => ({
    authenticationMode: recipient.authenticationMode || EsigningProviderAuthenticationModeSlug.Email,
    email: recipient.email,
    firstName: recipient.firstName,
    lastName: recipient.lastName,
    label: recipient.label,
    title: recipient.title,
    mobile: recipient.mobile,
});
export const mapDefaultViewerRecipient = (recipient) => ({
    email: recipient.email,
    firstName: recipient.firstName,
    lastName: recipient.lastName,
    label: recipient.label,
});
